// extracted by mini-css-extract-plugin
export default {"container":"TradimgView_container__CA6vO"};